<template>
    <div class="flex flex-col items-center justify-center text-center w-full" :style="heightStyle">
        <slot v-if="hasTemplate"></slot>
        <template v-else>
            <div v-if="heightNum > 200" class="block w-full">
                <span class="flex justify-center w-full">
                    <img :src="`${$baseUrl}/core/image/6.svg`" alt="No Data" class="h-[200px] w-auto max-w-full " />
                </span>
            </div>
            <span class="mt-8 text-gray-300 dark:text-gray-600 text-3xl font-bold">{{ message }}</span>
        </template>
    </div>
</template>


<script setup lang="ts">
import { ref, onMounted, computed, useSlots } from 'vue';

const props = defineProps<{
    status?: boolean;
    message?: string;
    height?: string | number;
}>();

// Slot-related computed properties 
const slots = defineSlots<{
    default?: () => any;
    [key: string]: ((props: { item: any; index: number }) => any) | (() => any) | null | undefined;
}>()

const heightStyle = ref<Record<string, string>>({});
const hasTemplate = computed(() => slots.default !== undefined);
const message = ref(props.message || 'No Data');
const heightNum = computed(() => Number(props.height || 300));

function resetHeight() {
    heightStyle.value['min-height'] = `${heightNum.value}px`;
}

onMounted(() => {
    resetHeight();
});
</script>

<style scoped></style>